<div class="main-input-form">
    <form #myForm="ngForm" (ngSubmit)="save()">
        <div class="input-wrapper">
            <div class="side-wrapper edit-form-title-wrapper">
                <div class="user-icon"></div>
                <p class="input-form-title">{{'HOME.ROLES_EDIT_TITLE' | translate}}</p>
            </div>

            <div class="menu-input-wrapper">
                <div class="tab-menu">
                    <div class="tab basic-info" (click)="setActiveTab('basic-info')"
                        [ngClass]="{'active': activetab=='basic-info'}">
                        <p>{{'HOME.ROLES_BASICINFO_TABTITLE' | translate}}</p>
                    </div>
                    <div class="tab additional-rights" (click)="setActiveTab('additional-rights')"
                        [ngClass]="{'active': activetab=='additional-rights'}">
                        <p>{{'HOME.ROLES_ADDITIONAL_TABTITLE' | translate}}</p>
                    </div>
                </div>
                <!--
              -->
                <div class="input-content">
                    <div class="basic-info" *ngIf="activetab == 'basic-info'">

                        <div class="section-wrapper">
                            <p class="section-title">{{'HOME.USERS_BASICINFO_GENERAL' | translate}}</p>
                        </div>

                        <div class="side-combiner">
                            <div class="side-input-container">
                                <div class="input-control">
                                    <div class="title"><label for="Name">{{'HOME.ROLES_BASICINFO_NAME' |
                                            translate}}</label></div>
                                    <input class="form-control" type="text" name="Name" [(ngModel)]="role.Name" />
                                </div>
                                <div class="input-control">
                                    <div class="title"><label for="Name">{{'HOME.ROLES_BASICINFO_DESCRIPTION' |
                                            translate}}</label></div>
                                    <textarea class="form-control" type="text" name="Description"
                                        [(ngModel)]="role.Description"></textarea>
                                </div>
                                <div class="input-control">
                                    <div class="title"><label for="DefaultUrl">{{'HOME.ROLES_BASICINFO_DEFAULTURL' |
                                            translate}}</label></div>
                                    <input class="form-control" type="text" name="DefaultUrl"
                                        [(ngModel)]="role.DefaultUrl" />
                                </div>
                            </div>
                            <!--
                          -->
                            <div class="side-input-container">
                                <div class="input-control">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="additional-rights" *ngIf="activetab == 'additional-rights'">

                        <div class="section-wrapper">
                            <p class="section-title">{{'HOME.USERS_ADDITIONAL_TABTITLE' | translate}}</p>
                        </div>

                        <div class="side-combiner">
                            <div class="side-input-container">

                                <div *ngFor="let rm of role.RightsFormModel; let i = index" class="input-control">

                                    <div *ngIf="rm.deleted != true"
                                        style="border: 1px solid #ccc; padding: 15px; margin-bottom: 25px;">
                                        <div style="text-align: right;">
                                            <a style="color: #ccd2d5;" *ngIf="i>0" (click)="remove(rm)">X</a>
                                        </div>

                                        <div *ngIf="i==0" class="title"><label for="AssignedModel">All models</label>
                                        </div>
                                        <div *ngIf="i>0" class="title"><label for="AssignedModel">Model</label></div>
                                        <select *ngIf="i>0" class="form-control" name="AssignedModel{{i}}"
                                            [(ngModel)]="rm.AssignedModel">
                                            <option *ngFor="let mod of componentData.DocumentModels"
                                                [value]="mod.Value">
                                                {{mod.Text}}
                                            </option>
                                        </select>

                                        <table class="table rights-table">
                                            <tbody>
                                                <tr>
                                                    <th>{{'HOME.USERS_ADDITIONAL_RIGHT' | translate}}</th>
                                                    <th><a (click)="allowAll(rm)">{{'HOME.USERS_ADDITIONAL_ALLOW' |
                                                            translate}}</a></th>
                                                    <th><a (click)="denyAll(rm)">{{'HOME.USERS_ADDITIONAL_DENY' |
                                                            translate}}</a>
                                                    </th>
                                                </tr>

                                                <tr *ngFor="let ri of rm.Rights">
                                                    <td>
                                                        {{ri.Description}}
                                                    </td>
                                                    <td>
                                                        <div class="checkbox">
                                                            <label>
                                                                <input type="checkbox" [(ngModel)]="ri.AllowSelected"
                                                                    [ngModelOptions]="{standalone: true}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="checkbox">
                                                            <label>
                                                                <input type="checkbox" [(ngModel)]="ri.DenySelected"
                                                                    [ngModelOptions]="{standalone: true}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <a class="add-rule" (click)="addNewAdditionalRights()"><img
                                        src="../../../../assets/images/linked-data-remove-link.png" /></a>
                            </div>
                            <!--
                              -->
                            <div class="side-input-container">
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </form>
</div>